export const INFLUITIVE_WILDCARD = '************';

export const INFLUITIVE_HELP_PAGE =
  'https://alyce.zendesk.com/hc/en-us/articles/25650395610907-Installing-the-Alyce-for-Influitive-integration';
